import api from "../../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/store?${p}`);
  },
  indexItemsList(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/item?${p}`);
  },
  indexStoreList(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/store?${p}`);
  },
  checkSn(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/check-sn?${p}`);
  },
  assignManagers(store_id, data) {
    return api.put(`/api/v1/store/${store_id}`, data);
  },
};
